var _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFbLike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.954 8.954 0 20 0s20 8.954 20 20-8.954 20-20 20S0 31.046 0 20z",
    fill: "url(#fb-like_svg__paint0_linear_427_109506)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.217 19.122c.408.287.783.572.783 1.573 0 1.003-.53 1.409-1.098 1.691.232.381.306.839.206 1.274-.178.803-.907 1.426-1.556 1.61.28.453.368.899.035 1.447-.428.688-.801.95-2.45.95H19.42c-2.288 0-3.474-1.274-3.474-2.334v-5.448c0-2.87 3.398-5.308 3.398-7.303l-.246-2.485c-.011-.152.019-.523.134-.63.186-.185.697-.467 1.471-.467.505 0 .84.096 1.237.287 1.345.646 1.695 2.282 1.695 3.598 0 .632-.959 2.527-1.089 3.183 0 0 2.008-.448 4.352-.465 2.457-.014 4.05.444 4.05 1.965 0 .609-.507 1.22-.732 1.554zm-19.828-.789h1.853c.369 0 .722.148.983.41.26.263.407.619.407.99V28.6c0 .371-.147.727-.407.99-.261.262-.614.41-.983.41H10.39c-.368 0-.721-.148-.982-.41A1.406 1.406 0 019 28.6v-8.867c0-.371.146-.727.407-.99.26-.262.614-.41.982-.41z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fb-like_svg__paint0_linear_427_109506",
    x1: 20,
    y1: 38.831,
    x2: 20,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1877F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19AFFF"
  })))));
}

export default SvgFbLike;